import script from "./Contatos.vue?vue&type=script&setup=true&lang=js"
export * from "./Contatos.vue?vue&type=script&setup=true&lang=js"

import "./Contatos.vue?vue&type=style&index=0&id=1aa98b0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa98b0c"]])

export default __exports__